module.exports = __webpack_public_path__ + "img/chanpinjuzhen.7da0c558.png";